import { CaseStatus, CaseType } from '@/@types/generated'
import EnumSelect, { EnumSelectProps } from '@/components/Atoms/EnumSelect'
import { JSX } from 'react'
import { CaseStatusLabels, CaseStatusTextColor } from '@/lib/format/CaseStatus'
import { cn } from '@/lib/utils.ts'

type SingleProps = Omit<
  Extract<EnumSelectProps<CaseStatus>, { single: true }>,
  'options' | 'itemFormatter'
> & {
  primaryCaseType?: CaseType
  showAll?: boolean
}

type MultiProps = Omit<
  Extract<EnumSelectProps<CaseStatus>, { single?: false }>,
  'options' | 'itemFormatter'
> & {
  primaryCaseType?: CaseType
  showAll?: boolean
}

type Props = SingleProps | MultiProps

export function CaseStatusSelect(props: SingleProps): JSX.Element
export function CaseStatusSelect(props: MultiProps): JSX.Element
export function CaseStatusSelect(props: Props) {
  const { primaryCaseType, showAll, ...rest } = props

  const options =
    primaryCaseType?.id === 21 || showAll
      ? Object.values(CaseStatus)
      : Object.values(CaseStatus).filter(
          (status) =>
            status !== CaseStatus.AV_NOI_NOTICE_OF_INTENT_MAILED &&
            status !== CaseStatus.AV_FD_FINAL_DETERMINATION_LTR_MAILED
        )

  return (
    <EnumSelect
      options={options}
      itemFormatter={(v) => (
        <div className="flex flex-1 items-center gap-2">
          <span
            className={cn(
              'relative h-4 text-4xl leading-3',
              CaseStatusTextColor[v]
            )}
          >
            &bull;
          </span>
          <span>{CaseStatusLabels[v]}</span>
        </div>
      )}
      {...rest}
    />
  )
}
